import './sentry';
import './bootstrap';
import './crud-edit';
import './refresh-csrf';

import Swal from 'sweetalert2';
window.Swal = Swal;

import.meta.glob([
    '../../public/images/**',
    '../../public/photos/**',
]);